<template>
  <div class="rectification-chart">
    <custom-panel>
      <template #title>隐患整改情况</template>
      <template #default>
        <div class="active-ring-chart">
          <div class="left">
            <dv-active-ring-chart :config="config" style="height: 100%;" v-if="dataLoaded"/>
          </div>
          <div class="right">
            <div class="legend-list" v-if="dataLoaded">
              <div class="legend-item" v-for="(item,index) in yinHuanZhengGaiQingKuang" :key="index">
                <div class="legend-box" :style="{backgroundColor: item.color}"></div>
                <span class="legend-label">{{ item.label }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="histogram-chart">
          <dv-charts :option="option" v-if="dataLoaded"/>
        </div>
      </template>
    </custom-panel>
  </div>
</template>
<script>
import CustomPanel from '../custom-panel/index.vue'
import request from '@/util/request.js'

export default {
  components: {
    CustomPanel
  },
  data () {
    return {
      timer: null,
      dataLoaded: false,
      yinHuanZhengGaiQingKuang: null,
      config: {
        lineWidth: 10,
        data: [],
        digitalFlopStyle: {
          fontSize: 12
        },
        color: [] // ,
        // showOriginValue: true
      },
      option: {
        title: {},
        xAxis: {
          data: [],
          axisLabel: {
            style: {
              fill: '#fff'
            }
          }
        },
        yAxis: {
          data: 'value',
          min: 0,
          axisLabel: {
            style: {
              fill: '#fff'
            },
            formatter: function ({ value }) {
              return parseInt(value)
            }
          }
        },
        series: [
          {
            independentColor: true,
            independentColors: [],
            data: [],
            type: 'bar',
            barWidth: 20,
            label: {
              show: true,
              style: {
                fill: '#fff'
              }
            }
          }
        ],
        grid: {
          top: 10
        }
      }
    }
  },
  created () {
    this.getYinHuanZhengGaiQingKuang()
  },
  methods: {
    async getYinHuanZhengGaiQingKuang () {
      const res = await request.get('/common/yin-huan-zheng-gai-qing-kuang')
      this.yinHuanZhengGaiQingKuang = res.data
      this.config.data = res.data.map(item => {
        return {
          name: item.label,
          value: item.count
        }
      })
      this.config.color = res.data.map(item => {
        return item.color
      })
      this.option.xAxis.data = res.data.map(item => {
        return item.label
      })
      this.option.series[0].independentColors = res.data.map(item => {
        return item.color
      })
      this.option.series[0].data = res.data.map(item => {
        return item.count
      })
      this.dataLoaded = true
    }
  },
  mounted () {
    this.timer = setInterval(() => {
      this.getYinHuanZhengGaiQingKuang()
    }, process.env.VUE_APP_DATA_REFRESH_INTERVAL)
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }
}
</script>
<style lang="scss" scoped>
.rectification-chart {
  height: 100%;

  .active-ring-chart {
    height: 40%;
    display: flex;

    .left {
      width: 60%;
      height: 100%;
    }

    .right {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 40%;
      height: 100%;

      .legend-list {

      }

      .legend-item {
        display: flex;
        align-items: center;

        &:not(:last-child) {
          margin-bottom: 8px;
        }
      }

      .legend-box {
        width: 30px;
        height: 16px;
      }

      .legend-label {
        padding-left: 8px;
        color: #fff;
        font-size: 12px;
      }
    }
  }

  .histogram-chart {
    height: 60%;
  }
}
</style>
